import React, { useState, useCallback } from 'react';

const Toast = ({ message, type = 'info', onClose }) => {
    const bgColor = type === 'error' ? '#e15759' : type === 'success' ? '#4caf50' : '#333';

    return (
        <div style={{
            position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999,
            backgroundColor: bgColor, color: '#fff', padding: '12px 20px',
            borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            fontSize: '14px', maxWidth: '360px', animation: 'fadeIn 0.3s ease',
        }}>
            {message}
        </div>
    );
};

export const useToast = () => {
    const [toast, setToast] = useState(null);

    const showToast = useCallback((message, type = 'info', duration = 3000) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), duration);
    }, []);

    const ToastContainer = toast ? (
        <Toast message={toast.message} type={toast.type} />
    ) : null;

    return { showToast, ToastContainer };
};

export default Toast;
